module.exports = __webpack_public_path__ + "media/curtain-opening.10efa42e.mp3";